import './App.css';
import supabase from './supabaseClient';
import React, { useEffect, useState } from "react";

// var selectedCategory = 'NA';
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function VoucherSection({ userid, year, month }) {
  const [voucher, setVoucher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    let isMounted = true;
    async function fetchVoucher() {
      setLoading(true);
      const { data } = await supabase
        .from('Vouchers')
        .select('*')
        .eq('userid', userid)
        .eq('year', year)
        .eq('month', month)
        .single();
      if (isMounted) {
        setVoucher(data || null);
        setLoading(false);
      }
    }
    if (userid && year && month) fetchVoucher();
    return () => { isMounted = false; };
  }, [userid, year, month]);

  const handleGenerate = async () => {
    setGenerating(true);

    // check if AppConfig allows redeeming points. 
    // look for record with key 'voucher_process_status' if it value is 'active' then proceed else alert user that voucher process is currently inactive
    const { data: config, error: configError } = await supabase
    .from('AppConfig')
    .select('value')
    .eq('key', 'voucher_process_status')
    .single();

    if (configError || !config || config.value !== 'active') {
      alert(config.value);
      setGenerating(false);
      return;
    }

    const { data: teamResponses, error: teamError } = await supabase
      .from('UserResponses')
      .select('userid, created_at')
      .in('userid', (await supabase
        .from('Users')
        .select('userid')
        .eq('referredby', userid)
      ).data?.map(u => u.userid) || [])
      .filter('created_at', 'gte', `${year}-${String(Number(month) + 1).padStart(2, '0')}-01`)
      .filter('created_at', 'lt', `${year}-${String(Number(month) + 2).padStart(2, '0')}-01`);

    if (teamError) {
      alert('Failed to fetch team responses.');
      setGenerating(false);
      return;
    }

    // Count responses per user
    const responseCount = {};
    (teamResponses || []).forEach(resp => {
      const uid = resp.userid;
      if (!responseCount[uid]) responseCount[uid] = 0;
      responseCount[uid]++;
    });

    // Count team members with >=100 responses
    const eligibleTeamMembers = Object.values(responseCount).filter(count => count >= 100).length;
    const teamPoints = eligibleTeamMembers * 10;

    // Check if current user is eligible (has 100+ responses in same month)
    const { data: myResponses, error: myError } = await supabase
      .from('UserResponses')
      .select('id')
      .eq('userid', userid)
      .filter('created_at', 'gte', `${year}-${String(Number(month) + 1).padStart(2, '0')}-01`)
      .filter('created_at', 'lt', `${year}-${String(Number(month) + 2).padStart(2, '0')}-01`);

    if (myError) {
      alert('Failed to check your eligibility.');
      setGenerating(false);
      return;
    }

    if ((myResponses || []).length < 100) {
      alert('You need at least 100 responses in the selected month to generate a voucher.');
      setGenerating(false);
      return;
    }

    if (teamPoints === 0) {
      alert('No eligible team members for voucher this month.');
      setGenerating(false);
      return;
    }

    // Generate a voucher number (simple random string)
    const voucherNumber = 'VCH-' + Math.random().toString(36).substr(2, 8).toUpperCase();
    // const now = new Date().toISOString();
    const { data, error } = await supabase
      .from('Vouchers')
      .insert([{
        userid,
        year,
        month,
        vouchernumber: voucherNumber,
        retailer:'xyz',
        type: 'team',
        amount: teamPoints, // Fixed amount for team vouchers
      }])
      .select()
      .single();
    if (!error) {
      setVoucher(data);
    } else {
      alert('Failed to generate voucher. Please try again.1' + error.message);
    }
    setGenerating(false);
  };

  if (loading) return <span style={{ alignSelf: 'center' }}>Checking voucher...</span>;

  if (voucher) {
    return (
      <div style={{
        background: '#e0ffe0',
        color: '#388e3c',
        padding: '12px 18px',
        borderRadius: '8px',
        fontWeight: 500,
        minWidth: 220,
        textAlign: 'center'
      }}>
        <div>
          <b>Voucher Already Generated</b>
        </div>
        <div>Voucher #: <span style={{ fontFamily: 'monospace' }}>{voucher.vouchernumber}</span></div>
        <div>Date: {voucher.createdat ? new Date(voucher.createdat).toLocaleString() : ''}</div>
      </div>
    );
  }

  return (
    <button
      style={{
        background: '#1976d2',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        padding: '8px 22px',
        fontSize: '1em',
        fontWeight: 600,
        cursor: generating ? 'not-allowed' : 'pointer',
        boxShadow: '0 1px 4px rgba(0,0,0,0.07)'
      }}
      disabled={generating}
      onClick={handleGenerate}
    >
      {generating ? 'Generating...' : 'Generate Voucher'}
    </button>
  );
}

function Team() { 
  const [data, setData] = useState([]);
  const [responses, setResponses] = useState([]);
  const [filterYear, setFilterYear] = useState('');
  const [filterMonth, setFilterMonth] = useState('');
  // Remove loading if not used in UI

  const [referralCode, setReferralCode] = useState('');

  useEffect(() => {
    async function fetchTeamAndResponses() {
      //fetch me referral code for display
      // Fetch current user's referral code
      const { data: userData } = await supabase
        .from('Users')
        .select('referralcode')
        .eq('userid', currentuserid.split('-')[0])
        .single();

      if (userData && userData.referralcode) {
        setReferralCode(userData.referralcode);
      }

      // Fetch team members
      const { data: users } = await supabase
        .from('Users')
        .select('*')
        .eq('referredby', currentuserid.split('-')[0])
        .order('userid', { ascending: true });

      setData(users || []);

      if (users && users.length > 0) {
        const userIds = users.map(u => u.userid);

        // Fetch responses for these users
        const { data: userResponses } = await supabase
          .from('UserResponses')
          .select('userid, created_at, PointsReceived')
          .in('userid', userIds);

          // Group responses by userid
          const grouped = {};
          (userResponses || []).forEach(resp => {
            if (!grouped[resp.userid]) {
              // Initialize the group with the first response
              grouped[resp.userid] = [resp.userid, resp.created_at, 1];
            } else {
              // Update the group with the latest response and increment count
              grouped[resp.userid] = [
                grouped[resp.userid][0],
                resp.created_at,
                grouped[resp.userid][2] + 1
              ];
            }
          });

        // Create a map for quick user lookup by userid
        const userMap = {};
        (users || []).forEach(u => {
          if (u && u.userid) {
            userMap[u.userid] = u;
          }
        });

        // Convert grouped object to array
        const responseArray = Object.values(grouped).map(resp => {
            return {
              userid: resp[0],
              username: userMap[resp[0]]?.username || 'Unknown',
              created_at: resp[1],
              PointsReceived: resp[2] > 100 ? '100+' : resp[2]
            };
        });
        setResponses(responseArray);
      } 
      else 
      {
        setResponses([]);
      }
    }

    if (currentuserid) {
      fetchTeamAndResponses();
    }
  }, []);


  return (
    <div style={{ padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '1.1em' }}>
      {/* Referral Code Section */}
      {referralCode && (
        <div style={{
          background: 'linear-gradient(90deg, blue 0%, #f7b731 100%)',
          color: '#fff',
          padding: '18px 24px',
          borderRadius: '12px',
          textAlign: 'center',
          margin: '18px auto 28px auto',
          width: 'fit-content',
          boxShadow: '0 2px 12px rgba(162,89,255,0.15)'
        }}>
          <div style={{ fontSize: '1.2em', fontWeight: 'bold', letterSpacing: '2px' }}>
            Your Referral Code:
            <span style={{
              background: '#fff',
              color: 'blue',
              borderRadius: '6px',
              padding: '6px 18px',
              marginLeft: '12px',
              fontSize: '1.3em',
              fontFamily: 'monospace',
              boxShadow: '0 1px 4px rgba(0,0,0,0.07)'
            }}>
              {referralCode}
            </span>
          </div>
          <div style={{ marginTop: '10px', fontSize: '1em', fontWeight: 500 }}>
            Share this code with friends and grow your team! 🚀
          </div>
        </div>
      )}

      {!referralCode && (
        <div style={{
          background: '#ffe0e0',
          color: 'blue',
          padding: '18px 24px',
          borderRadius: '12px',
          textAlign: 'center',
          margin: '18px auto 28px auto',
          width: 'fit-content',
          boxShadow: '0 2px 12px rgba(162,89,255,0.10)'
        }}>
          <div style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
            You have not generated a referral code so far.
          </div>
          <button
            style={{
              marginTop: '14px',
              background: 'blue',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 22px',
              fontSize: '1em',
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 1px 4px rgba(0,0,0,0.07)'
            }}
            onClick={async () => {
              // Fetch username for current user
              const { data: user } = await supabase
                .from('Users')
                .select('username')
                .eq('userid', currentuserid.split('-')[0])
                .single();

              let username = user?.username || 'user';
              // Remove spaces and non-alphanumeric, make lowercase
              username = username.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

              // Generate random alphanumeric string
              function randomString(length) {
                const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < length; i++) {
                  result += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                return result;
              }

              // Compose referral code: part of username + random string, 5-10 chars
              let codeBase = username.substring(0, 5);
              let codeLength = Math.max(5, Math.min(10, codeBase.length + 3));
              let referral = (codeBase + randomString(codeLength - codeBase.length)).substring(0, codeLength);

              // Save referral code to Supabase
              const { error: updateError } = await supabase
                .from('Users')
                .update({ referralcode: referral })
                .eq('userid', currentuserid.split('-')[0]);

              if (!updateError) {
                setReferralCode(referral);
              } else {
                alert('Failed to generate referral code. Please try again.2');
              }
            }}
          >
            Generate Referral Code
          </button>
        </div>
      )}

      <h3 style={{ color: 'blue', textAlign: 'center' }}>Your Team</h3>
      {data && data.length > 0 ? (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '2fr 2fr', 
          gap: '10px', 
          alignItems: 'center',
          width: '80%',
          margin: '0 auto'
        }}>
          {/* <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>UserID</div> */}
          <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Name</div>
          <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Registered On</div>
          {data.map((user, idx) => (
            <React.Fragment key={user.id}>
              {/* <div>{user.userid}</div> */}
              <div>{user.username}</div>
              <div>{user.created_at ? new Date(user.created_at).toLocaleString() : ''}</div>
            </React.Fragment>
          ))}
        </div>
      ) : (
        
        <div style={{ background: '#f0f4f8', padding: '24px', borderRadius: '8px', maxWidth: 800 }}>
          <p>No team members found.</p>
        </div>
      )}

      <br />
      <h3 style={{ color: 'blue', textAlign: 'center' }}>Your Team Member Points</h3>
      <div style={{
        background: '#eaf6ff',
        color: '#1a237e',
        padding: '18px 24px',
        borderRadius: '10px',
        margin: '18px auto 28px auto',
        width: 'fit-content',
        boxShadow: '0 2px 12px rgba(26,35,126,0.08)',
        fontSize: '1em',
        maxWidth: 700
      }}>
        <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#1976d2' }}>
          Rules for Team Gift Vouchers:
        </div>
        <ol style={{ paddingLeft: '20px', margin: 0 }}>
          <li style={{ marginBottom: '6px' }}>
            Team vouchers can only be generated for <b>past months</b>, not the current ongoing month.
          </li>
          <li style={{ marginBottom: '6px' }}>
            Team members who have responded to at least <b>100 questions</b> in a calendar month will contribute <b>10 points</b> to your gift voucher.
          </li>
          <li>
            You will be eligible to generate a gift voucher from your team's contribution if <b>you</b> have responded to <b>100 or more questions</b> in that calendar month.
          </li>
        </ol>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', gap: '10px' }}>
        <select
          value={filterYear}
          onChange={e => setFilterYear(e.target.value)}
          style={{ padding: '5px' }}
        >
          <option value="">Select Year</option>
          {Array.from(
            new Set(
              (responses || [])
                .map(r => r.created_at && new Date(r.created_at).getFullYear())
                .filter(Boolean)
            )
          )
            .sort((a, b) => b - a)
            .map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
        </select>
        <select
          value={filterMonth}
          onChange={e => setFilterMonth(e.target.value)}
          style={{ padding: '5px' }}
        >
          <option value="">Select Month</option>
          {Array.from(
            new Set(
              (responses || [])
                .map(r => r.created_at && new Date(r.created_at).getMonth())
                .filter(m => m !== undefined && m !== null)
            )
          )
            .sort((a, b) => a - b)
            .map(month => (
              <option key={month} value={month}>
                {new Date(0, month).toLocaleString('default', { month: 'long' })}
              </option>
            ))}
        </select>
        

        {filterYear && filterMonth && (
          <VoucherSection
            userid={currentuserid.split('-')[0]}
            year={filterYear}
            month={filterMonth}
          />
        )}
      </div>

      {(filterYear === "" || filterMonth === "") ? (
        <div style={{ background: '#fffbe0', padding: '24px', borderRadius: '8px', maxWidth: 800, margin: '0 auto', textAlign: 'center', color: 'blue', fontWeight: 500 }}>
          Please select both year and month to view data.
        </div>
      ) : (
        (responses && responses.length > 0) ? (
          <div style={{
            display: 'grid',
            gridTemplateColumns: '2fr 2fr 2fr 2fr',
            gap: '10px',
            width: '80%',
            alignItems: 'center',
            margin: '0 auto'
          }}>
            <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Name</div>
            <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Date</div>
            <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Responses</div>
            {/* <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Gift Voucher Eligibility</div> */}
            <div style={{ fontWeight: 'bold', borderBottom: '2px solid blue' }}>Points Contributed</div>
            {responses
              .filter(resp => {
                if (!resp.created_at) return false;
                const date = new Date(resp.created_at);
                return (
                  date.getFullYear().toString() === filterYear &&
                  date.getMonth().toString() === filterMonth
                );
              })
              .map((resp, idx) => {
                let score = resp.PointsReceived === '100+' ? 100 : Number(resp.PointsReceived) || 0;
                let eligibility;
                if (score >= 100) {
                  eligibility = 'Yes';
                } else {
                  eligibility = `${100 - score} more required`;
                }
                return (
                  <React.Fragment key={resp.id || idx}>
                  {/* <div>{resp.userid}</div> */}
                  <div>{resp.username}</div>
                  <div>
                    {resp.created_at
                    ? new Date(resp.created_at).toLocaleString('default', { month: 'long' })
                    : ''}
                  </div>
                  <div>{resp.PointsReceived}</div>
                  {/* <div>{eligibility}</div> */}
                  <div>{eligibility === 'Yes' ? 10 : 0}</div>
                  </React.Fragment>
                );
              })}
            {
              // If no filtered data, show message
              responses.filter(resp => {
                if (!resp.created_at) return false;
                const date = new Date(resp.created_at);
                return (
                  date.getFullYear().toString() === filterYear &&
                  date.getMonth().toString() === filterMonth
                );
              }).length === 0 && (
                <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: 'blue', padding: '16px' }}>
                  No responses found for selected year and month.
                </div>
              )
            }
          </div>
        ) : (
          <div style={{ background: '#f0f4f8', padding: '24px', borderRadius: '8px', maxWidth: 800 }}>
            <p>No responses found.</p>
          </div>
        )
      )}
      <div style={{ height: '60px' }}></div>
    </div>
  );
}

export default Team;